import { trackLike } from '../utils/tracking/track-like';

export type useOptimisticReactionsUpdateProps = (
  propChannel?: string,
  urn?: string,
  inputHintClick?: boolean
) => { handleOnComplete: (data: any) => void };

export const useOptimisticReactionsUpdate: useOptimisticReactionsUpdateProps = (
  propChannel = '',
  urn = '',
  inputHintClick = false
) => {
  //TODO: FIX THIS AFTER MIGRATING THE QUERIES
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleOnComplete = (data: any) => {
    const like =
      data?.socialCreateReaction?.success?.interactionTarget ?? undefined;
    const unlike =
      data?.socialDeleteReaction?.success?.interactionTarget ?? undefined;

    if (like) trackLike({ hasLike: true, urn, propChannel, inputHintClick });
    if (unlike) trackLike({ hasLike: false, urn, propChannel, inputHintClick });
  };

  return { handleOnComplete };
};
